import Hidden, { HiddenProps } from '@material-ui/core/Hidden';

import * as React from 'react';

export type DSHiddenProps = HiddenProps;
export const DSHidden: React.FC<DSHiddenProps & { children: React.ReactNode}> = props => <Hidden {...props} />;
DSHidden.displayName = 'DSHidden';
